export default __webpack_public_path__ + "static/media/dispute_art.4bf2875f.png";